import { summarizeCouponsByCategory } from "@/store/coupons";
import type { Coupon } from "@/store/types";

/**
 * Chips showing which categories the member's remaining coupons can be redeemed
 * against, with the remaining-use count per category. Hidden when the member has
 * no usable coupons.
 */
export default function CouponCategoryChips({ coupons }: { coupons: Coupon[] }) {
  const summary = summarizeCouponsByCategory(coupons);
  if (summary.length === 0) return null;

  return (
    <div className="agd:mt-4.5 agd:flex agd:flex-wrap agd:items-center agd:gap-2">
      <span className="agd:mr-0.5 agd:text-[0.72rem] agd:font-semibold agd:uppercase agd:tracking-wide agd:text-muted-foreground">
        Coupons available for
      </span>
      {summary.map((s) => (
        <span
          key={s.category}
          className="agd:inline-flex agd:items-center agd:gap-1.5 agd:rounded-full agd:border agd:border-[#fcd9b6] agd:bg-[#fff7ed] agd:py-1 agd:pl-3 agd:pr-2 agd:text-[0.85rem] agd:font-semibold agd:text-[#b45309]"
        >
          {s.label}
          <span className="agd:inline-block agd:min-w-[20px] agd:rounded-full agd:bg-accent agd:px-1.5 agd:text-center agd:text-[0.72rem] agd:leading-[19px] agd:text-white">
            {s.count}
          </span>
        </span>
      ))}
    </div>
  );
}
